import { useSelector } from 'react-redux'
import { Typography } from '@vp/swan'
import { tileEntityByIdSelector } from '~/app/store/tileEntity'
import { getShowSets } from '~/app/store/debug'

export interface PropTypes {
  entityId: string
}

export const RankingSetDisplay = ({ entityId }: PropTypes) => {
  const showSets = useSelector(getShowSets)
  const tileEntityById = useSelector(tileEntityByIdSelector)
  const tileEntity = tileEntityById(entityId)

  if (!showSets || !tileEntity?.rankingSet) {
    return null
  }

  return (
    <div className="ranking-set-display">
      <Typography fontSize="standard" fontWeight="bold">
        Set: {tileEntity.rankingSet}
      </Typography>
    </div>
  )
}
